"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasOpenedChest = void 0;
const WorldCharacter_1 = require("../classes/WorldCharacter");
const definables_1 = require("definables");
const getWorldState_1 = require("./state/getWorldState");
const hasOpenedChest = (chestID) => {
    const worldState = (0, getWorldState_1.getWorldState)();
    const worldCharacter = (0, definables_1.getDefinable)(WorldCharacter_1.WorldCharacter, worldState.values.worldCharacterID);
    return worldCharacter.player.character.party.players.every((player) => player.worldCharacter.openedChestIDs.includes(chestID));
};
exports.hasOpenedChest = hasOpenedChest;
